export default import.meta.ROLLDOWN_FILE_URL_sB3tJnhu95b2xe93amOGHw